import React from "react"

/**
 * `Icon` hands every DS glyph its colour as `fill`, but this one is drawn in strokes: left in
 * the spread it would land on the <svg>'s own `fill="none"` and flood the cube solid. Taking it
 * as the stroke keeps the outline the design asks for (Figma 9418:260435).
 */
export const Box = ({ height = 20, width = 20, stroke = "#525455", fill, ...props }) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_4569_98457)">
      <path d="M17.5 13.3333V6.66663C17.4997 6.37435 17.4225 6.0873 17.2763 5.83426C17.13 5.58122 16.9198 5.37109 16.6667 5.22496L10.8333 1.89163C10.58 1.74535 10.2926 1.66833 10 1.66833C9.70744 1.66833 9.42003 1.74535 9.16667 1.89163L3.33333 5.22496C3.08022 5.37109 2.86998 5.58122 2.72372 5.83426C2.57745 6.0873 2.5003 6.37435 2.5 6.66663V13.3333C2.5003 13.6256 2.57745 13.9126 2.72372 14.1657C2.86998 14.4187 3.08022 14.6288 3.33333 14.775L9.16667 18.1083C9.42003 18.2546 9.70744 18.3316 10 18.3316C10.2926 18.3316 10.58 18.2546 10.8333 18.1083L16.6667 14.775C16.9198 14.6288 17.13 14.4187 17.2763 14.1657C17.4225 13.9126 17.4997 13.6256 17.5 13.3333Z" stroke={fill || stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.72461 5.80078L9.99961 10.0091L17.2746 5.80078" stroke={fill || stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 18.4V10" stroke={fill || stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_4569_98457">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
